import { render, staticRenderFns } from "./tabMenu.vue?vue&type=template&id=9a92f78e&"
import script from "./tabMenu.vue?vue&type=script&lang=js&"
export * from "./tabMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports